export enum EditAccountScreenLocators {
	userAccountsDropdown = 'userAccountsDropdown',
	userNavigationButton = 'userNavigationButton',
}
